export default function hexToRgba(rawHex, alpha) {
  const cleanHex = rawHex.replace('#', '');

  const splitHexValues = cleanHex.length === 3 ?
  cleanHex.split('').reduce((acc, v) => [...acc, v, v], []) :
  cleanHex.match(/.{2}/g);

  if (splitHexValues) {
    const [r, g, b] = splitHexValues.map((v) => parseInt(v, 16));
    return `rgba(${[r, g, b, alpha || 1].join(',')})`;
  }

  return rawHex;
}